import React from 'react';
import { Wrap, WrapItem } from '@fiverr-private/layout_components';
import { Heading } from '@fiverr-private/typography';
import { Tabs } from '../Tabs';
import { sup } from './styles.ve.css';

export const PressReleasesHeader = () => (
  <Wrap direction="row" justifyContent="spaceBetween">
    <WrapItem order={{ default: 2, md: 1 }}>
      <Heading as="h1" fontFamily="primary" style={{ fontWeight: 300 }}>
        Fiverr
        <sup className={sup}>®</sup> press
      </Heading>
    </WrapItem>
    <Tabs />
  </Wrap>
);
